<template>
  <v-app id="app">
    <div v-bind:id="[currentUser ? 'wrapper' : '']"  >
      <Navigation v-if="currentUser && !['Login', 'AddInfo','IQuestions'].includes($route.name)"></Navigation>
      <div  v-bind:id="[currentUser ? 'content-wrapper' : '']" v-bind:class="[currentUser ? 'd-flex flex-column' : '']">
        <div v-bind:id="[currentUser ? 'content' : '']">
          <ContentNavBar v-if="currentUser && !['Login'].includes($route.name)"></ContentNavBar>
          <transition name="slide">
            <router-view></router-view>
          </transition>
        </div>
        <Footer v-if="currentUser"></Footer>
      </div>
    </div>
    <a class="scroll-to-top rounded" href="#page-top">
      <i class="fas fa-angle-up"></i>
    </a>
  </v-app>
</template>

<script>
import Navigation from "./components/Navigation.vue";
import ContentNavBar from "./components/ContentNavBar.vue";
import Footer from "./components/Footer.vue";
import Login from "./components/login/Login.vue";
import { mapState } from "vuex";

export default {
  name: "app",
  components: {
    Navigation,
    ContentNavBar,
    Footer,
    Login,
  },
  computed: {
    ...mapState(["currentUser"]),
  },
  methods: {
    beforeEnter () {
      this.$root.$emit('scrollBeforeEnter');
    }
  }
}
</script>

<style>
.v-application .body-2 {
    font-size: 0.875rem !important;
    font-weight: 400;
    letter-spacing: 0.0378571429em !important;
    line-height: 1.25rem;
    font-family: "Arial", sans-serif !important;
}
</style>